export default __webpack_public_path__ + "static/media/2b5b256ab83f9279626ab851169aa135.png";